import angular from 'angular';
import MostSelledProductsComponent from './most-selled-products.component';

let MostSelledProductsModule = angular.module('catalog.mostSelledProducts', [])
  .component('mostSelledProducts', MostSelledProductsComponent);

export default MostSelledProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/most-selled-products/most-selled-products.js
 **/